import React, { useState, useEffect } from 'react';
import { IonHeader, IonToolbar, IonTitle, IonContent, IonPage, IonButtons, IonMenuButton, IonGrid, IonRow, IonCol, IonSearchbar, IonRefresher, IonRefresherContent } from '@ionic/react';
import SpeakerItem from '../components/SpeakerItem';
import { Speaker } from '../models/Speaker';
import { Session } from '../models/Schedule';
import { connect } from '../data/connect';
import * as selectors from '../data/selectors';
import { setSpeakerSearchText } from '../data/sessions/sessions.actions';
import EmptyStateMessage from '../components/EmptyStateMessage';
import { getConfData } from '../data/dataApi';
import './SpeakerList.scss';

interface OwnProps { };

interface StateProps {
  speakers: Speaker[];
  speakerSessions: { [key: string]: Session[] };
};

interface DispatchProps {
  setSpeakerSearchText: typeof setSpeakerSearchText;
};

interface SpeakerListProps extends OwnProps, StateProps, DispatchProps { };

const SpeakerList: React.FC<SpeakerListProps> = ({ speakers, speakerSessions, setSpeakerSearchText }) => {
  const [isRefreshing, setIsRefreshing] = useState(false);
  const [hasSpeakers, setHasSpeakers] = useState(true);

  // Verificar si hay conferencistas disponibles
  useEffect(() => {
    setHasSpeakers(speakers && speakers.length > 0);
  }, [speakers]);

  // Función para refrescar los datos
  const doRefresh = async (event?: CustomEvent) => {
    try {
      setIsRefreshing(true);
      await getConfData();
    } catch (error) {
      console.error('Error al refrescar los datos:', error);
    } finally {
      setIsRefreshing(false);
      if (event) {
        event.detail.complete();
      }
    }
  };

  return (
    <IonPage id="speaker-list">
      <IonHeader translucent={true}>
        <IonToolbar>
          <IonButtons slot="start">
            <IonMenuButton />
          </IonButtons>
          <IonTitle>Conferencistas</IonTitle>
        </IonToolbar>
        <IonToolbar>
          <IonSearchbar
            placeholder="Buscar conferencistas"
            onIonChange={(e: CustomEvent) => setSpeakerSearchText(e.detail.value)}
            animated={true}
            debounce={300}
            inputmode="search"
            enterkeyhint="search"
            showCancelButton="never"
          />
        </IonToolbar>
      </IonHeader>

      <IonContent fullscreen={true}>
        <IonRefresher slot="fixed" onIonRefresh={(e) => doRefresh(e)}>
          <IonRefresherContent></IonRefresherContent>
        </IonRefresher>

        <IonHeader collapse="condense">
          <IonToolbar>
            <IonTitle size="large">Conferencistas</IonTitle>
          </IonToolbar>
        </IonHeader>

        {!hasSpeakers && !isRefreshing ? (
          <EmptyStateMessage
            type="speakers"
            message="No se encontraron conferencistas para este evento."
            onRefresh={() => doRefresh()}
          />
        ) : (
          <IonGrid fixed>
            <IonRow>
              {speakers
                .filter(speaker => speaker.name && speaker.name.trim() !== '')
                .map(speaker => (
                <IonCol size="12" size-md="6" key={speaker.id}>
                  <SpeakerItem
                    key={speaker.id}
                    speaker={speaker}
                    sessions={speakerSessions[speaker.name] || []}
                  />
                </IonCol>
              ))}
            </IonRow>
          </IonGrid>
        )}
      </IonContent>
    </IonPage>
  );
};

export default connect<OwnProps, StateProps, DispatchProps>({
  mapStateToProps: (state) => ({
    speakers: selectors.getSpeakers(state),
    speakerSessions: selectors.getSpeakerSessions(state)
  }),
  mapDispatchToProps: {
    setSpeakerSearchText
  },
  component: React.memo(SpeakerList)
});